const baseCanonicalUrl = 'https://www.owndays.com/sg/en/services';

export const SERVICES = [
  {
    metaTitle: 'Retail Price | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: 'services/price',
    keywords:
      'retail price,glasses,spectacles,optical shop,eyeglasses,price,no additional charge,lenses,Singapore,OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/img/services/price/ogp_1200x630.jpg',
    description: `OWNDAYS offers an all-in-one price system that is simple and easy to understand. Every pair of glasses in OWNDAYS comes in a set price inclusive of a pair of high index aspheric lenses.`,
    canonicalUrl: `${baseCanonicalUrl}/price`,
  },
  {
    metaTitle: 'Lens Replacement | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/services/lens-replacement',
    keywords: 'Lens Replacement,glasses,spectacles,optical shop,eyeglasses,Singapore,OWNDAYS',
    ogImage:
      'https://static.lenskart.com/media/owndays/img/services/lens-replacement/ogp_1200x630.jpg',
    description: `In OWNDAYS, we offer lens replacement service even for spectacles bought at other shops. Prices start from $98 for standard high index aspheric lenses. You can opt for lens upgrades at simple price too. Our optional lenses include progressive lenses, PC lenses, colour lenses, transitions lenses and polarised lenses.`,
    canonicalUrl: `${baseCanonicalUrl}/lens-replacement`,
  },
  {
    metaTitle: 'LENS GUIDE | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/services/lens',
    keywords: 'LENS GUIDE,glasses,spectacles,optical shop,eyeglasses,Singapore,OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/img/services/lens/ogp_1200x630.jpg',
    description: `The lenses we use in OWNDAYS are high index aspheric lenses manufactured by top international lens makers. There is no additional charge for standard lenses of any power. We also offer optional lenses such as progressive lenses, PC lenses, colour lenses, transitions lenses, polarised lenses and myopia control lenses.`,
    canonicalUrl: `${baseCanonicalUrl}/lens`,
  },
  {
    metaTitle: 'Customer Guarantees | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/services/warranty',
    keywords:
      'Customer Guarantees,Change,Returns,glasses,spectacles,optical shop,eyeglasses,Singapore,OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/img/services/warranty/ogp_1200x630.jpg',
    description: `Proper care and regular maintenance can extend the lifespan of your spectacles. OWNDAYS offers you the most comprehensive after-sales service in the optical industry so you can enjoy your OWNDAYS spectacles at all times.`,
    canonicalUrl: `${baseCanonicalUrl}/services/warranty`,
  },
  {
    metaTitle: 'Staff | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/services/staff',
    keywords: 'Staff,glasses,spectacles,optical shop,eyeglasses,Singapore,OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/img/services/staff/ogp_1200x630.jpg',
    description: `We believe staff training is paramount in helping us achieve service excellence. That’s why our staff undergo regular trainings to improve their product knowledge and service standard. We are confident of meeting your expectation and delivering your spectacles to you in as fast as 20 minutes.`,
    canonicalUrl: `${baseCanonicalUrl}/staff`,
  },
  {
    metaTitle: 'OWNDAYS care+ | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/services/care',
    keywords: 'care,Warranty,Frame,glasses,spectacles,optical shop,eyeglasses,Singapore,OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/img/services/care/ogp_1200x630.jpg',
    description: `Enhance Your Spectacle Frame Warranty for 1 Year.`,
    canonicalUrl: `${baseCanonicalUrl}/care`,
  },
  {
    metaTitle: 'New Users Sign Up | OWNDAYS Online Optical Store',
    targetPath: '/services/onlinestore',
    keywords: 'New Users, glasses, spectacles, optical shop, eyeglasses, OWNDAYS',
    ogImage: 'https://static1.lenskart.com/owndays/img/services/ogp_1200x630.jpg',
    description: `At OWNDAYS, we are constantly striving to provide the highest level of service quality to all our customers. Prices start from S$98 for a spectacle frame with high index aspheric lenses. For added assurance, we also offer customers the most comprehensive warranty and after-sales service in the optical industry.`,
    canonicalUrl: `${baseCanonicalUrl}/onlinestore`,
  },
  {
    metaTitle: 'Services | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/services',
    keywords: 'Services,glasses,spectacles,optical shop,eyeglasses,Singapore,OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/img/services/ogp_1200x630.jpg',
    description: `At OWNDAYS, we are constantly striving to provide the highest level of service quality to all our customers. Prices start from S$98 for a spectacle frame with high index aspheric lenses. For added assurance, we also offer customers the most comprehensive warranty and after-sales service in the optical industry.`,
    canonicalUrl: `${baseCanonicalUrl}`,
  },
];
